import React from "react"
import { uuid } from "uuidv4"

export const DateSelectorCard = props => {
    const inputId = uuid()
    return <div onClick={() => { if (props.onChange != null) document.getElementById(inputId).showPicker() }} style={{ position: 'relative', cursor: props.onChange != null ? 'pointer' : 'default', width: '200px', display: 'flex', flexDirection: 'column', backgroundColor: 'white', border: '1px solid lightgrey', boxShadow: '0px 0px 2px lightgrey', padding: '10px', fontSize: '16px', gap: '5px', borderRadius: '5px', color: 'grey' }}>
        <span>{props.label}</span>
        <span style={{ fontWeight: 'bold' }}>{props.value}</span>
        <input type='date' style={{ width: '0', height: '0', position: 'absolute', bottom: '0', left: '0', border: '0' }} id={inputId} onChange={(evt) => { if (props.onChange != null) props.onChange(evt.target.valueAsDate) }}></input>
    </div>
}